import Axios from "axios";
import useAuthStore from "../../stores/useAuthStore";
import { DRAWER_TIMEOUT_MS, reportDeviceFailure } from "../hardware/hardwareStatus";

const CWOpenDrawer = (trigger = "sale") => {
  if (window.electronAPI?.hardware?.openDrawerConfigured) {
    window.electronAPI.hardware.openDrawerConfigured(trigger);
    return;
  }

  const tillData = useAuthStore.getState().tillData;
  const printerURL = tillData?.tillAccess?.cwrTill?.hardwareController?.imageUrl;
  if (!printerURL) {
    console.warn("[CWOpenDrawer] No hardwareController.imageUrl configured — skipping");
    return;
  }

  let openDrawerPayload = {
    cash_drawer: {
      action: "open",
    },
  };
  Axios.post(`${printerURL}printer`, openDrawerPayload, {
    notAPrint: true,
    timeout: DRAWER_TIMEOUT_MS,
    headers: {
      "Content-Type": "application/xml; charset=UTF-8",
      Accept: "application/xml",
    },
  }).catch((err) => {
    // Was silent: the cashier only saw a drawer that did not open.
    console.warn("[CWOpenDrawer] failed:", err?.message);
    reportDeviceFailure("drawer", err);
  });
};

export default CWOpenDrawer;
